import HeaderProvider from '@Providers/HeaderProvider';
import { Box } from '@mui/material';
import SecondaryNavigation from './SecondaryNavigation';
import { Outlet } from '@tanstack/react-router';

const MainLayout = () => {
    return (
        <>
            <SecondaryNavigation />
            <Box
                display="flex"
                flexDirection="column"
                flex={1}
                px={3}
                minWidth={0}
            >
                <HeaderProvider>
                    <Box
                        id="main-content"
                        flex={1}
                        overflow="auto"
                        display="flex"
                        flexDirection="column"
                        pb={3}
                    >
                        <Outlet />
                    </Box>
                </HeaderProvider>
            </Box>
        </>
    );
};

export default MainLayout;
